import * as React from 'react';
import Select from '../select';
const MiniSelect = props => <Select {...props} size="small"/>;
const MiddleSelect = props => <Select {...props} size="middle"/>;
MiniSelect.Option = Select.Option;
MiddleSelect.Option = Select.Option;
export { MiniSelect, MiddleSelect };
